import { MAX_ONLINE_ITEMS } from "../../thor.const";

export class OnlineContainerMissingFieldController {
    public static $inject: string[] = ["$mdDialog", "$mdMedia", "utilsService"];

    public container: any; // bind from parent (OnlineContainerEditController::initiatePublish)

    public maxItemsNbr: number = MAX_ONLINE_ITEMS;

    constructor(private $mdDialog, public $mdMedia, public utilsService) {}

    public displayGeneralInformations(): boolean {
        return Boolean(
            !this.container.resource.name ||
            !this.container.resource.description ||
            !this.container.resource.datetime ||
            !this.container.items?.length ||
            this.container.getItemsPublishCount() > this.maxItemsNbr ||
            this.container.resource.isPast
        );
    }

    public displayConditions(): boolean {
        return !this.container.resource.sale_conditions ||
            !this.container.isCommissionRateFilled() ||
            !this.container.isShippingFilled();
    }

    public hide() {
        this.$mdDialog.hide();
    }

    public hasInvalidItemsDescriptions(): boolean {
        return this.container.items.some(item =>
            !item.valid &&
            (!item.description || item.description.length < this.container.itemDescriptionMinLength)
        );
    }
}
